/**
 * Строковое представление значения произвольного типа — для подписей, ключей и сравнений.
 *
 * Свойства объектов приходят из чужого GeoJSON и внешних API, поэтому их тип —
 * `unknown`: там законно лежат вложенные объекты и массивы. Голый `String(value)`
 * на таком значении даёт `"[object Object]"` — в карточке объекта это уезжает
 * пользователю, а в ключах и идентификаторах схлопывает разные значения в одно.
 *
 * Правила:
 * - `null` / `undefined` → пустая строка (большинство мест уже писало `String(v ?? '')`);
 * - строка — как есть, без лишнего прохода через `String`;
 * - число / булево / bigint — обычное приведение;
 * - объект и массив — JSON; циклическая ссылка (JSON.stringify бросает) → пустая строка;
 * - функция и symbol — пустая строка: их текстовое представление бессмысленно как подпись.
 */
export function stringifyPropertyValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') {
    return String(value);
  }
  if (typeof value === 'function' || typeof value === 'symbol') return '';
  try {
    // `undefined` возвращает сам JSON.stringify — например, для объекта с toJSON(): undefined.
    return JSON.stringify(value) ?? '';
  } catch {
    return '';
  }
}
